/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiGroupTdhInclusionStrategy } from '../models/ApiGroupTdhInclusionStrategy';
import { HttpFile } from '../http/http';

export class ApiGroupTdhFilter {
    'min': number | null;
    'max': number | null;
    'inclusion_strategy': ApiGroupTdhInclusionStrategy;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "min",
            "baseName": "min",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "max",
            "baseName": "max",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "inclusion_strategy",
            "baseName": "inclusion_strategy",
            "type": "ApiGroupTdhInclusionStrategy",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiGroupTdhFilter.attributeTypeMap;
    }

    public constructor() {
    }
}


